import { useState } from 'react';
import i18n from 'i18n-js';

import { RenderChart, StatisticsPerPeriod } from '@components/ncFiles/components/paid';
import { getMax } from '@components/ncFiles/components/paid/components/barChart/calculation';
import { UseManagePaidBarChartParams, UseManagePaidBarChartReturn } from '@components/ncFiles/components/paid/components/barChart/types';

export const useManagePaidBarChart = ({
  renderChart,
  selectedIndex,
  chartWidth,
  barAmount,
  barValueName,
  lineValueName,
  average,
  averagePaid,
  showAverage,
}: UseManagePaidBarChartParams): UseManagePaidBarChartReturn => {
  const chartHeight = 151;
  const rightLegendFontOffset = 10;

  const item = renderChart[selectedIndex] || {};

  const maxValue = getMax({ item: item as RenderChart, barValueName, lineValueName, average, averagePaid, showAverage }) || 60;

  const barBlockWidth = chartWidth / barAmount;
  const barWidth = barBlockWidth * 0.66;

  const formatLegend = (v: number) => {
    const mins = v / 60;
    const hours = v / 60 / 60;
    if (hours > 1) {
      return `${hours}${i18n.t('h')}`;
    }
    if (mins > 1) {
      return `${mins}${i18n.t('m')}`;
    }
    return `${v}${i18n.t('s')}`;
  };

  const [selectedBarIndex, setSelectedBarIndex] = useState<number | null>(null);
  const [selectedBar, setSelectedBar] = useState<StatisticsPerPeriod | null>(null);

  return {
    item: item as RenderChart,
    chartHeight,
    rightLegendFontOffset,
    maxValue,
    barBlockWidth,
    barWidth,
    formatLegend,
    selectedBarIndex,
    setSelectedBarIndex,
    selectedBar,
    setSelectedBar,
  };
};
